<div class="db-filters" [formGroup]="filtersForm">
  <div class="db-filters-wrap">
    <div>
      <ds-dropdown [dsDropdownOptions]="clientsList"
                   [dsDropdownPlaceHolder]="'All users'"
                   [dsDropdownFullyHover]="true"
                   [dsDropdownListMaxHeight]="'211px'"
                   [dsDropdownOneLine]="true"
                   [formControlName]="'filterByClient'"
                   (onOptionChoose)="filterActivities()">
      </ds-dropdown>
    </div>

    <div>
      <ds-dropdown [dsDropdownOptions]="actionsList"
                   dsDropdownPlaceHolder="All actions"
                   [dsDropdownFullyHover]="true"
                   [dsDropdownListMaxHeight]="'211px'"
                   [formControlName]="'filterByAction'"
                   (onOptionChoose)="filterActivities()">
      </ds-dropdown>
    </div>

    <div *ngIf="filtersForm.controls['filterByAction'].value === 'website' && websites.length">
      <ds-dropdown [dsDropdownOptions]="websites"
                   dsDropdownPlaceHolder="All websites"
                   [dsDropdownFullyHover]="true"
                   [dsDropdownListMaxHeight]="'211px'"
                   [dsDropdownOneLine]="true"
                   [formControlName]="'filterByWebsite'"
                   (onOptionChoose)="filterActivities()">
      </ds-dropdown>
    </div>

    <div *ngIf="filtersForm.controls['filterByAction'].value === 'website'
              && websites.length && hasStagingEnv">
      <ds-dropdown [dsDropdownOptions]="websiteEnvTypes"
                   dsDropdownPlaceHolder="Live Environment"
                   [dsDropdownFullyHover]="true"
                   [dsDropdownOneLine]="true"
                   [dsDropdownListMaxHeight]="'211px'"
                   [formControlName]="'filterByWebsiteType'"
                   (onOptionChoose)="filterActivities()">
      </ds-dropdown>
    </div>

    <div>
      <db-datepicker-select displayMonths="2" [canSelectRange]="true"
                            [startDate]="displayStartDate" [endDate]="displayEndDate"
                            (dateSelect)="dateFilter($event)" (dateClear)="clearDateFilter()"></db-datepicker-select>
    </div>
  </div>


  <div>
    <button class="ds-btn" (click)="clearDateFilter(true)"><span>Reset</span></button>
  </div>
</div>
